<template>
  <div class="flex items-center lg:order-2">
    <div v-if="authStore.isConnected">
      <router-link
          :to="{ name: 'app_profil' }"
          class="button mr-5 border-2 border-primary-700 hover:bg-primary-300 transition-colors focus:outline-none font-medium rounded-full text-sm p-5 relative text-center inline-flex items-center"
      >
        <i class="fa-regular fa-user text-xl text-primary-700 absolute left-1/2 -translate-x-1/2"></i>
      </router-link>
      <router-link
          :to="{ name: 'app_view_cart' }"
          class="button relative border-2 border-primary-700 hover:bg-primary-300 font-medium rounded-full text-sm p-5 text-center inline-flex items-center"
      >
        <i class="fa-solid fa-cart-shopping text-xl text-primary-700 absolute left-1/2 -translate-x-1/2 hover:text-white"></i>
        <div v-if="numberArticle > 0" class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-primary-950 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">
          {{ numberArticle }}
        </div>
      </router-link>
    </div>
    <div v-else class="flex items-center">
      <router-link
          :to="{ name: 'app_register' }"
          title="Créer mon compte"
          class="button mr-5 border-2 font-bold text-primary-700 hover:text-white uppercase border-primary-700 hover:bg-primary-300 rounded-full text-sm px-7 py-2.5 relative text-center inline-flex items-center"
      >
        Nous rejoindre
        <i class="fa-solid fa-right-long ml-3"></i>
      </router-link>
      <router-link
          :to="{ name: 'app_login' }"
          title="Me connecter"
          class="button mr-5 border-2 border-primary-700 hover:bg-primary-300 transition-colors focus:outline-none font-medium rounded-full text-sm p-5 relative text-center inline-flex items-center"
      >
        <i class="fa-solid fa-right-to-bracket text-xl text-primary-700 absolute left-1/2 -translate-x-1/2"></i>
      </router-link>
    </div>
    <button @click="emitter.emit('open-menu')" class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100">
      <span class="sr-only">Open main menu</span>
      <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
      <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
    </button>
  </div>
</template>
<script>
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";

export default {
  name: 'AuthentificationBouton',
  computed: {
    ...mapStores(useAuthStore),
    numberArticle () {
      return this.authStore.getNumberOfArticles
    }
  }
}
</script>

<style>
.button i {
  transition: color 0.3s ease-in-out;
}

.button {
  transition: all 0.3s ease-in-out;
}

.button:hover i {
  color: white!important;
  transition: color 0.3s ease-out;
}
</style>